import type { SxProps, Theme } from "@mui/material"
import { gridClasses } from "@mui/x-data-grid-premium"
import {
  GO_TO_FINDER_HEADER_CLASS,
  HEADER_CELL_PADDING,
  HEADER_ICON_SLOT_WIDTH,
  HEADER_LINE_HEIGHT,
  HEADER_MAX_LINES,
} from "../constants"

const HEADER_CELL = `&&& .${gridClasses.columnHeader}`
const HEADER_MENU_ICON = `&&& .${gridClasses.columnHeaders} .${gridClasses.columnHeader} .${gridClasses.menuIcon}`

const WORDS_CLAMP_RULES = Object.fromEntries(
  Array.from({ length: HEADER_MAX_LINES }, (_, index) => [
    `${HEADER_CELL} .MuiCustomHeader-words[data-clamp-lines="${index + 1}"]`,
    {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: index + 1,
      overflow: "hidden",
    },
  ]),
)

export const CONTRIBUTORS_HEADER_SX = {
  [HEADER_CELL]: {
    paddingRight: `${HEADER_CELL_PADDING}px`,
  },
  [`${HEADER_CELL}:not(.${GO_TO_FINDER_HEADER_CLASS})`]: {
    paddingLeft: `${HEADER_CELL_PADDING}px`,
  },
  [`${HEADER_CELL} .MuiCustomHeader-text`]: {
    flex: "1 1 0",
    minWidth: 0,
    whiteSpace: "normal",
    textOverflow: "clip",
    textAlign: "center",
  },
  [`${HEADER_CELL} .MuiCustomHeader-text-wrapper`]: {
    display: "block",
  },
  [`${HEADER_CELL} .MuiCustomHeader-label`]: {
    display: "block",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    lineHeight: `${HEADER_LINE_HEIGHT}px`,
  },
  [`${HEADER_CELL}.${GO_TO_FINDER_HEADER_CLASS} .MuiCustomHeader-label`]: {
    overflowWrap: "normal",
  },
  ...WORDS_CLAMP_RULES,
  [`${HEADER_CELL} .MuiCustomHeader-unit`]: {
    display: "inline-block",
    whiteSpace: "nowrap",
    overflowWrap: "normal",
  },
  [`${HEADER_CELL} .MuiCustomHeader-unit[data-own-line]`]: {
    display: "block",
  },
  [`${HEADER_CELL} .MuiCustomHeader-gutter`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: `0 0 ${HEADER_ICON_SLOT_WIDTH}px`,
    width: HEADER_ICON_SLOT_WIDTH,
    alignSelf: "stretch",
  },
  [`${HEADER_CELL} .MuiCustomHeader-sortIcon`]: {
    margin: 0,
    padding: "2px",
  },
  [`${HEADER_CELL} .MuiCustomHeader-gutter .cell-tooltip-info`]: {
    fontSize: 14,
  },
  [`${HEADER_MENU_ICON}, ${HEADER_MENU_ICON}:hover`]: {
    flex: `0 0 ${HEADER_ICON_SLOT_WIDTH}px`,
    width: HEADER_ICON_SLOT_WIDTH,
    margin: 0,
  },
  [`${HEADER_CELL} .${gridClasses.menuIconButton}`]: {
    padding: "2px",
  },
} satisfies SxProps<Theme>

export const CONTRIBUTORS_GRID_SX = { borderRadius: 0, ...CONTRIBUTORS_HEADER_SX } satisfies SxProps<Theme>
